import BookmarksModel from './bookmarks-model';
import BookmarksView from './bookmarks-view';

export default class BookmarksPresenter {
  constructor(model, view, appInterface) {
    this.model = model || new BookmarksModel();
    this.view = view || new BookmarksView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.model.loadUserState();

    if (!this.model.isAuthenticated) {
      this.view.hideClearAllSection();
      this.view.showAuthRequired('#bookmarks-container', () => this.appInterface.navigateTo('auth'));
      return;
    }
    
    this.loadBookmarks();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.view.setupEventListeners(
      () => this.showClearAllDialog(),
      (storyId) => this.removeBookmark(storyId),
      (storyId) => this.removeBookmark(storyId),
      (storyId) => this.sharePost(storyId),
      (id) => this.appInterface.navigateToPost(id),
      (src) => this.appInterface.showLightbox(src)
    );
  }

  loadBookmarks() {
    const globalBookmarksData = this.appInterface.getBookmarks();
    this.model.updateGlobalBookmarks(globalBookmarksData);

    const bookmarksWithDistance = this.model.getBookmarksWithDistance();
    const sortedBookmarks = this.model.getSortedBookmarks();
    
    if (sortedBookmarks.length === 0) {
      this.view.showEmptyState('#bookmarks-container', 'Belum ada postingan tersimpan');
      this.view.updateClearAllButton(0);
      return;
    }

    const bookmarksToRender = sortedBookmarks.map(bookmark => {
      const withDistance = bookmarksWithDistance.find(b => b.storyId === bookmark.storyId);
      return {
        ...bookmark,
        distance: withDistance ? withDistance.distance : null
      };
    });

    this.view.renderBookmarks(bookmarksToRender, '#bookmarks-container', (postId) => this.appInterface.navigateToPost(postId));
    this.view.updateClearAllButton(sortedBookmarks.length);
    
    const stats = this.model.getBookmarkStats();
    this.view.showBookmarkStats(stats);
    
    this.loadLocationNames(sortedBookmarks);

    this.appInterface.reinitTooltips();
  }

  async loadLocationNames(bookmarks) {
    for (const bookmark of bookmarks) {
      if (bookmark.lat && bookmark.lon) {
        try {
          const locationName = await this.model.getLocationName(bookmark.lat, bookmark.lon);
          this.view.updateLocationName(bookmark.storyId, locationName);
        } catch (error) {
          this.view.updateLocationName(bookmark.storyId, 'Lokasi tidak ditemukan');
        }
      }
    }
  }

  removeBookmark(storyId) {
    const success = this.model.removeBookmark(storyId);
    
    if (success) {
      this.appInterface.setBookmarks([...this.model.bookmarks]);
      this.appInterface.updateBookmarkBubble();
      this.appInterface.showToast('Postingan dihapus dari bookmark', 'success');
      
      this.view.removeBookmarkFromDOM(storyId);
      
      const remainingCount = this.model.getBookmarkCount();
      this.view.updateClearAllButton(remainingCount);

      if (remainingCount === 0) {
        this.view.showEmptyState('#bookmarks-container', 'Belum ada postingan tersimpan');
      }

      const stats = this.model.getBookmarkStats();
      this.view.showBookmarkStats(stats);
    }
  }

  clearAllBookmarks() {
    this.model.clearAllBookmarks();
    
    this.appInterface.setBookmarks([]);
    this.appInterface.updateBookmarkBubble();
    
    this.loadBookmarks();
    this.appInterface.showToast('Semua bookmark telah dihapus', 'success');
  }

  showClearAllDialog() {
    const bookmarkCount = this.model.getBookmarkCount();
    
    if (bookmarkCount === 0) {
      this.appInterface.showToast('Tidak ada bookmark untuk dihapus', 'warning');
      return;
    }
    
    this.appInterface.showConfirmDialog(
      `Hapus semua ${bookmarkCount} bookmark? Tindakan ini tidak dapat dibatalkan.`,
      () => this.clearAllBookmarks()
    );
  }

  sharePost(storyId) {
    const baseUrl = this.appInterface.getCurrentUrl();
    const url = `${baseUrl}#/share/${storyId}`;
    this.appInterface.setShareUrl(url);
    this.appInterface.showDialog('share-dialog');
  }

  refresh() {
    this.model.loadUserState();
    this.loadBookmarks();
  }

  cleanup() {
    this.view.cleanup();
  }
}